import React from 'react';
import { useRouter } from 'next/router';

import './CoursesInfo.scss';
import icons from '../../shared/assets/icons/redesign';
import { trackAction, usePlatform } from '../../helpers/tracking';

const { Check, Logo } = icons;

export default function CoursesInfo() {
  const router = useRouter();
  const platform = usePlatform();

  return (
    <div className="coursesInfo">
      <div className="coursesInfo-header">
        <Logo />

        <span className="coursesInfo-close-icon" onClick={() => {
          router.back();

          trackAction(platform, 'coursesinfo', 'clickclosebutton');
        }}>
          &times;
        </span>
      </div>

      <h2 className="coursesInfo-title">
        Welkom in de online cursussen omgeving
      </h2>

      <p className="coursesInfo-text">
        Gezond en gelukkig zwanger zijn en met het volste vertrouwen de babytijd
        in: dat gaat lukken met deze tien prachtige cursussen. Die volg je hier
        online, en onbeperkt gedurende 18 maanden.
      </p>

      <ul className="coursesInfo-list">
        <li className="coursesInfo-list-item">
          <div className="coursesInfo-list-item-icon-wrap">
            <Check className="coursesInfo-list-item-icon" />
          </div>
          18 maanden onbeperkt toegang tot 10 online cursussen
        </li>

        <li className="coursesInfo-list-item">
          <div className="coursesInfo-list-item-icon-wrap">
            <Check className="coursesInfo-list-item-icon" />
          </div>
          Afgestemd op je zwangerschap, bevalling, de babytijd en je partner
        </li>

        <li className="coursesInfo-list-item">
          <div className="coursesInfo-list-item-icon-wrap">
            <Check className="coursesInfo-list-item-icon" />
          </div>
          Gratis, afhankelijk van je verzekering. Anders maar 99,99 euro voor
          het hele pakket
        </li>

        <li className="coursesInfo-list-item">
          <div className="coursesInfo-list-item-icon-wrap">
            <Check className="coursesInfo-list-item-icon" />
          </div>
          Meer dan 100 video’s en 1000+ minuten materiaal
        </li>
      </ul>

      <button
        className="coursesInfo-button"
        onClick={() => {
          router.push('/zwangerschapscursus/welkom');

          trackAction(platform, 'coursesinfo', 'clicknextbutton');
        }}
      >
        Verder
      </button>
    </div>
  );
}
